import React from 'react';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';

export const WebLayout = ({ children }) => {
  return (
    <div>
      <Navbar />
      {children}
      <Footer />
    </div>
  );
};
